// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2938":"9b30dc645396c053","4273":"1993e8127ee77605","4396":"23dc7cc026bdd0bf","4884":"88c9da7f1fddd069","6020":"eae1a8ccac55b0bf","6198":"8c37952b59c19a91"}[chunkId] + ".js";
};